export const TRAIN_MODE = 2;
export const REST_MODE = 3;
export const WARM_UP_MODE = 4;
export const RELAX_MODE = 5;

export const A_MAP_MAX_ZOOM_LEVEL = 18;
export const GOOGLE_MAP_MAX_ZOOM_LEVEL = 22;

export const SPORT_TYPE = {
  SNOW_BOARD: 501,
  SKI_BOARD: 500,
  OPEN_WATER: 301,
  ROWING: 700,
  ROWING_MACHINE: 701,
  SPORT_FIELD_RUNNING: 103,
  CLIMB: 106,
  MOUNTAIN_SKIING: 503
};
